const isIOS = () => {
  const device = navigator.userAgent.toLowerCase();
  return device.match(/(iphone|ipod|ipad)/);
};

export { isIOS };
